import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import { ClickActionEvent } from '../../util/analytics'

import youtubeVideoes from "./Data"
 



export default function Youtube() {
  
  const sxCard = { height: '100%', display: 'flex', flexDirection: 'column' };
  const sxCardHover = { ...sxCard, boxShadow: '0 4px 8px 0 rgba(0,0,255,0.8), 0 6px 20px 0 rgba(0,0,255,0.8)', cursor: 'pointer', opacity: 0.7, transition: '0.2s linear' };
  const sxCardMedia = { paddingTop: '22.25%', height: 70 };
  const sxCardContent = { flexGrow: 1 };

  const [selectedItem, setSelectedItem] = React.useState('')

  const MouseOver = (t)  =>{
    setSelectedItem(t)
    
  }

  const MouseOut = (event)  =>{
    setSelectedItem('')
  }

  return (
    <React.Fragment>
 
      <div style={{backgroundColor:"#dbf5f0"}}>

        <Box sx={{ py: 8, backgroundColor: '#dbf5f0' }}>
          <Container maxWidth="md">
            <Typography component="h1" variant="h3" align="center" color="textPrimary" gutterBottom>
              My Youtube Videos <YouTubeIcon fontSize="large" style={{color:"red"}}/>
            </Typography>
            <Typography variant="h6" align="center" color="textSecondary" paragraph>
              Hey! geeks take it easy 😃, these videos are mix of college days(with limited knowledge/resource) and recent creativity(based on professional experiences).
              I know there is always room for improvement, you will see the improvement in the content if you compare old and latest viodeos.
              Old videos are kept to keep alive the college day's Javed and new videos is to represent latest version of Javed. Something new is alwas cooking (but slowly)...🐻 Bear with me...
            </Typography>
          </Container>
        </Box>
        <Container sx={{ pt: 8, pb: 8 }} maxWidth="md">
          <Grid container spacing={4}>
            {youtubeVideoes.map((item) => (
              <Grid item key={item.id} xs={12} sm={6} md={4}>
               <Link href={item.deployedLink} target="_blank" rel="noreferrer noopener" onClick={()=>{ClickActionEvent('Youtube '+item.name, 'youtube section', 'youtube link clicked')}}> 
                <Card sx={item.name===selectedItem?sxCardHover:sxCard} style={{backgroundColor:"#a4e5e0"}} onMouseOver={()=>MouseOver(item.name)} onMouseOut={MouseOut}>
                  
                  <CardMedia
                    sx={sxCardMedia}
                    image={process.env.PUBLIC_URL + item.image}
                    title={item.name}
                  />
                  
                  <CardContent sx={sxCardContent}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {item.name} <TouchAppIcon/>
                    </Typography>
                    <Typography>
                      {item.description}
                    </Typography>
                  </CardContent>
                </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
          <p> <a href="https://www.youtube.com/@javedinfinite" target="_blank" rel="noreferrer noopener">Check out all the videos on my Youtube Channel</a></p>
        </Container>
      </div>
 
    </React.Fragment>
  );
}
